import { useEffect, useState } from "react";
import "../ProjetoLicenciamentoAmbiental/Projeto.css";
import BannerPaginaInterna from "../BannerPaginaInterna/BannerPaginaInterna.js";
import Projetos from "../Projetos/Projetos.js";
import Contato from "../Contato/Contato.js";
import progEduAmb1 from "../../assets/img/projetos/progEduAmb1.png";
import progEduAmb2 from "../../assets/img/projetos/progEduAmb2.png";
import progEduAmb3 from "../../assets/img/projetos/progEduAmb3.png";
import progEduAmb4 from "../../assets/img/projetos/progEduAmb4.png";
import progEduAmb5 from "../../assets/img/projetos/progEduAmb5.png";
import progEduAmb6 from "../../assets/img/projetos/progEduAmb6.png";
import Servicos from "../Servicos/Servicos.js";
import { FaMountain, FaSeedling, FaWater, FaShieldAlt } from "react-icons/fa";

function ProjetoProgramaEducacaoAmbiental() {
  const [openItem, setOpenItem] = useState(1);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const elements = document.querySelectorAll(".scroll-reveal-zoom");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("visible");
        });
      },
      { threshold: 0.2 },
    );

    elements.forEach((el) => observer.observe(el));
    return () => elements.forEach((el) => observer.unobserve(el));
  }, []);

  return (
<div className="bg-white">
      <BannerPaginaInterna
        tag="Sustentabilidade e ESG"
        titulo="Programa de Educação Ambiental(PEA)"
        descricao="Programa de educação ambiental para comunidades e empresas."
        textoBotao="Solicitar Orçamento"
        rotaBotao="https://wa.me/5532984053160?text=Olá, quero um orçamento para Projeto de Programa de Educação Ambiental(PEA)"
        mostrarBotaoOutline={true}
        textoBotaoOutline="Fale com Especialista"
        rotaBotaoOutline="https://wa.me/5532984053160?text=Olá, quero falar com um especialista em Projeto de Programa de Educação Ambiental(PEA)"
      />

      <main className="projetos-page py-5 container">
        <section className="s scroll-reveal-zoom">
          <div className="titulo-bloco">
            <h2>Educação Ambiental com Impacto Mensurável</h2>
            <p>
              Como Estruturamos um PEA Estratégico para Comunidades da Mineração
            </p>
          </div>

          <div className="scroll-reveal-zoom">
            <p>
              Promover{" "}
              <strong>
                educação ambiental em territórios impactados pela mineração
              </strong>{" "}
              não é apenas uma exigência legal, é uma oportunidade estratégica
              de gerar valor social, fortalecer o relacionamento com a
              comunidade e consolidar <strong>práticas ESG</strong> na operação.
            </p>

            <p>
              Este case mostra como estruturamos e executamos o{" "}
              <strong>Programa de Educação Ambiental Externo (PEA)</strong> para
              a Nexa, transformando uma demanda regulatória em um programa{" "}
              <strong>contínuo, engajador e com resultados mensuráveis</strong>.
            </p>

            <p>
              O programa não se configura como uma iniciativa pontual, mas como
              um <strong>projeto contínuo</strong>, desenvolvido desde 2022 pela
              mesma equipe técnica, com evolução anual a partir das demandas da
              Nexa, das instituições de ensino e do perfil dos participantes.
            </p>

            <p>
              A partir de 2025, com a estruturação da Âmbar, a condução do
              programa foi mantida pela mesma equipe, garantindo{" "}
              <strong>continuidade metodológica</strong>,{" "}
              <strong>consistência</strong> e aproveitamento do conhecimento
              acumulado ao longo dos ciclos.
            </p>
          </div>

          <section className="images-section scroll-reveal-zoom">
            <div className="container">
              <div className="images-grid progEduAmb">
                <div className="image-card">
                  <img src={progEduAmb1} alt="" className="img-fluid" />
                </div>
                <div className="image-card">
                  <img src={progEduAmb2} alt="" className="img-fluid" />
                </div>
                <div className="image-card">
                  <img src={progEduAmb3} alt="" className="img-fluid" />
                </div>
                <div className="image-card">
                  <img src={progEduAmb4} alt="" className="img-fluid" />
                </div>
                <div className="image-card">
                  <img src={progEduAmb5} alt="" className="img-fluid" />
                </div>
                <div className="image-card">
                  <img src={progEduAmb6} alt="" className="img-fluid" />
                </div>
              </div>
            </div>
          </section>

          <div className="case-destaque scroll-reveal-zoom">
            <h5>Quando a Educação Ambiental Precisa Ir Além da Obrigação Legal</h5>
            <p>
  O projeto foi desenvolvido para atender às <strong>condicionantes ambientais da Nexa</strong>, com foco em <strong>alunos do ensino fundamental</strong> e <strong>comunidades da área de influência direta</strong>.
</p>

<p>
  Mais do que cumprir uma exigência, o desafio era estruturar um <strong>programa capaz de gerar engajamento real</strong>, <strong>aprendizado significativo</strong> e <strong>impacto perceptível no território</strong>.
</p>

<p>
  Ao longo da execução, o contexto trouxe <strong>desafios relevantes</strong>, como <strong>mudanças no calendário escolar</strong>, <strong>substituição de professores</strong>, <strong>diferenças de perfil entre turmas</strong> e <strong>limitações logísticas</strong>.
</p>

<p>
  Esse cenário exigiu mais do que um planejamento técnico, exigiu <strong>capacidade de adaptação</strong> sem perda de <strong>qualidade e consistência</strong>.
</p>
          </div>

          <div className="case-destaque scroll-reveal-zoom">
            <h5>
             A Estratégia: Transformar Conteúdo em Experiência
            </h5>
            <p>
  A solução não poderia se limitar a <strong>ações pontuais</strong> ou <strong>conteúdos expositivos</strong>.
</p>

<p>
  A estratégia adotada foi a <strong>estruturação de um programa contínuo</strong>, dividido em duas <strong>frentes complementares</strong>:
</p>

<ul className="lista-prad">
  <li><strong>PEA Escola</strong></li>
  <li><strong>Projeto Monitores Ambientais</strong></li>
</ul>

<p>
  O foco foi transformar a <strong>educação ambiental em uma experiência prática e aplicada</strong>, com <strong>atividades colaborativas</strong>, <strong>construção coletiva de soluções</strong> e <strong>conexão direta com a realidade dos participantes</strong>.
</p>

<p>
  A continuidade do programa ao longo dos anos permitiu o <strong>refinamento da abordagem metodológica</strong>, com <strong>ajustes progressivos</strong> baseados na experiência prática, no retorno da escola e na evolução do público atendido.
</p>

<p>
  Esse processo resultou em uma <strong>linha condutora integrada</strong>, que combina <strong>consistência técnica</strong> com <strong>flexibilidade operacional</strong>.
</p>
          </div>

          <div className="case-destaque scroll-reveal-zoom">
            <h5>Da Teoria à Prática: Como Estruturamos o Programa</h5>
           <p>
  A execução do <strong>PEA</strong> foi conduzida de forma <strong>integrada</strong>, contemplando <strong>planejamento técnico e pedagógico</strong>, <strong>desenvolvimento de conteúdos</strong>, <strong>execução em campo</strong> e <strong>monitoramento contínuo</strong>.
</p>

<p>
  As ações incluíram <strong>oficinas temáticas</strong>, <strong>desenvolvimento de maquetes e painéis</strong>, <strong>atividades práticas</strong> e <strong>visitas técnicas</strong>, como <strong>Parque da Lajinha</strong> e <strong>Centro de Ciências da UFJF</strong>.
</p>

<p>
  Entre <strong>abril e novembro de 2025</strong>, foram realizadas <strong>21 ações</strong>, com <strong>95 participantes diretos</strong>, consolidando um <strong>ciclo contínuo de aprendizado e engajamento</strong>.
</p>
          </div>

          <div className="case-destaque scroll-reveal-zoom">
            <h5>
              O Resultado: Engajamento, Aprendizado e Impacto Real
            </h5>
            <p>
  Os resultados do programa mostram que a <strong>abordagem adotada foi capaz de gerar impacto concreto</strong>, tanto em <strong>indicadores</strong> quanto na <strong>transformação percebida pelos participantes</strong>.
</p>

<ul className="lista-prad">
  <li><strong>82% de presença nas atividades</strong></li>
  <li><strong>67% dos participantes desenvolveram pensamento crítico</strong></li>
  <li><strong>78% dos monitores com percepção positiva sobre o futuro</strong></li>
  <li><strong>93% de percepção positiva da comunidade</strong></li>
</ul>

<p>
  Os resultados observados em <strong>2025</strong> refletem não apenas a execução de um <strong>ciclo anual</strong>, mas a <strong>maturação de um programa contínuo</strong>, construído ao longo dos anos e <strong>aprimorado progressivamente</strong>.
</p>
          </div>

          <div className="case-destaque scroll-reveal-zoom">
            <h5>Mais do que Resultado: Formação de Protagonismo e Valor para o Território</h5>
            <p>
  O impacto do programa vai <strong>além dos indicadores</strong>.
</p>

<p>
  Ao longo do ciclo, os participantes passaram a desenvolver <strong>maior senso crítico</strong>, compreender sua <strong>relação com o meio ambiente</strong> e assumir um <strong>papel mais ativo dentro da comunidade</strong>.
</p>

<p>
  Um destaque relevante foi a <strong>evolução da primeira turma</strong> que concluiu o ciclo completo, iniciado no <strong>6º ano</strong> e finalizado no <strong>9º ano</strong>, apresentando <strong>maior autonomia</strong> e <strong>capacidade de aplicar o conhecimento na prática</strong>.
</p>

<p>
  Para a <strong>Nexa</strong>, o programa também representou <strong>fortalecimento do relacionamento com a comunidade</strong>, <strong>atendimento estruturado às condicionantes ambientais</strong> e <strong>consolidação de uma agenda ESG aplicada na prática</strong>.
</p>
          </div>

          <div className="case-destaque scroll-reveal-zoom">
            <h5>Por Que Esse Case é Relevante para o Seu Projeto</h5>
            <p>
  Este projeto demonstra que <strong>programas de educação ambiental podem ir muito além do cumprimento legal</strong>.
</p>

<p>
  Quando bem estruturados, tornam-se <strong>ferramentas estratégicas</strong> capazes de gerar <strong>impacto social mensurável</strong>, <strong>engajar comunidades de forma consistente</strong> e <strong>fortalecer a reputação institucional</strong>.
</p>

<p>
  A continuidade do programa desde <strong>2022</strong>, associada à <strong>manutenção da equipe técnica ao longo dos ciclos</strong>, demonstra a capacidade da <strong>Âmbar</strong> de desenvolver <strong>soluções duradouras</strong>, com <strong>evolução consistente</strong> e <strong>geração de valor ao longo do tempo</strong>.
</p>
          </div>

          <div className="cta-container">
            <div className="cta-text">
              <h3>Precisa Estruturar um Programa de Educação Ambiental?</h3>

              <p>
               Se sua empresa precisa atender condicionantes ambientais, fortalecer o relacionamento com comunidades ou estruturar um programa socioambiental consistente, é possível fazer isso com estratégia e impacto real.
              </p>

              <p>
               Atuamos de forma integrada, desde o Diagnóstico Socioambiental Participativo (DSP) até a estruturação, implementação e acompanhamento de programas de educação ambiental, projetos socioambientais e soluções ESG alinhadas à realidade de cada empreendimento.
              </p>

              <p>
               Entre em contato e entenda como podemos estruturar um programa eficiente para o seu projeto.
              </p>
            </div>
<div className="cta-button-wrapper">
              <a
                href="https://wa.me/5532984053160?text=Olá, gostaria de solicitar um orçamento para elaboração de um projeto de educação ambiental"
                target="_blank"
                rel="noopener noreferrer"
                className="cta-button"
              >
                Orçamento
              </a>
            </div>
          </div>
        </section>
      </main>
      <Projetos />
      <Servicos />
      <Contato />
    </div>
  );
}

export default ProjetoProgramaEducacaoAmbiental;
